import { PenaltiesService } from '@fair-play/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AddCardCommandPayload } from './add-card.command-payload';
import { CreateUserPenaltyDto } from '@core-http';

export class AddCardCommandHandler {
  private readonly playerProfileService: PenaltiesService = inject(PenaltiesService);

  add(payload: AddCardCommandPayload): Observable<void> {
    const dto: CreateUserPenaltyDto = this.mapToDto(payload);
    return this.playerProfileService.addCard(dto, { userId: payload.userId });
  }

  private mapToDto(payload: AddCardCommandPayload): CreateUserPenaltyDto {
    return {
      gameId: payload.gameId,
      reason: payload.reason,
      penaltyType: payload.penaltyType
    };
  }
}
